<template>
  <div class="module-container">
    <div class="module-header">
      <div class="module-title" style="font-weight: bolder;">
        <span>报事管理</span>
      </div>
      <span class="more-link" @click="goToReportMan">查看更多</span>
    </div>
    <div class="module-content">
      <div class="total-container">
        <div class="total-info">
          <div class="total-number">{{ totalNumber }}</div>
          <div class="total-label">总单数</div>
        </div>
      </div>
      <div class="stats-container">
        <div class="stat-item" v-for="item in statsData" :key="item.label">
          <span class="stat-label">{{ item.label }}</span>
          <div class="value-wrapper">
            <span class="stat-value">{{ item.value }}</span>
            <span class="stat-unit">{{ item.unit }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { orderStatistics } from '@/api/reportMan'
import { addDate, getCurTimeYMD } from '@/utils/index'

export default {
  name: 'IncidentManagement',
  data() {
    return {
      statsData: [],
      totalNumber: 0,
      loading: false,
      refreshInterval: null
    }
  },
  mounted() {
    this.fetchOrderData()
    // 设置定时刷新，每30分钟刷新一次
    this.refreshInterval = setInterval(this.fetchOrderData, 1800000)
  },
  beforeDestroy() {
    // 清除定时器，避免内存泄漏
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval)
    }
  },
  methods: {
    async fetchOrderData() {
      this.loading = true
      // 先清空数据，确保即使数据不变也能触发重新渲染
      this.totalNumber = 0
      this.statsData = []
      try {
        const projectId = JSON.parse(window.localStorage.userInfo).projectId;
        const endDate = getCurTimeYMD();
        const startDate = addDate(endDate, -7);
        const { data } = await orderStatistics({
          projectId: projectId,
          startDate: startDate,
          endDate: endDate
        })
        if (data) {
          this.totalNumber = data.data.totalNum || 0
          this.statsData = [
            { label: '完成单数', value: data.data.finishNum || 0, unit: '单' },
            { label: '执行中', value: data.data.progressNum || 0, unit: '单' },
            { label: '超时率', value: data.data.overTimeRate || 0, unit: '%' },
            { label: '完成率', value: data.data.finishRate || 0, unit: '%' }
          ]
        }
      } catch (error) {
        console.error('获取报事数据失败:', error)
      } finally {
        this.loading = false
      }
    },
    goToReportMan() {
      // 获取用户权限
      const userRoles = JSON.parse(decodeURI(window.localStorage.userRoles))
      // 计算日期参数（最近7天）
      const endDate = getCurTimeYMD()
      const startDate = addDate(endDate, -7)

      // 检查是否有报事管理权限
      if (userRoles && userRoles.includes('baoshiguanlichakan')) {
        // 有权限，跳转到报事管理
        this.$router.push({
          path: '/matterMan/matterManagement',
          query: {
            startDate,
            endDate
          }
        });
      } else {
        // 无权限，提示
        this.$message({
          type: 'warning',
          message: '您暂无权限访问报事管理'
        });
      }
    }
  }
}</script>

<style scoped lang="scss">
.module-container {
  display: flex;
  flex-direction: column;
}

.module-header {
  display: flex;
  align-items: center;
}

.module-title {
  width: 435px;
  height: 35px;
  color: #fff;
  text-align: center;
  background: url("/static/image/equip/shebeiyunxingzhuangtai-bg.png") no-repeat center;

  span {
    margin-left: -186px;
    font-family: Source Han Sans CN;
    font-weight: 800;
    font-size: 19px;
    color: #FFFFFF;
  }
}

.more-link {
  font-size: 12px;
  color: #fff;
  cursor: pointer;
  transition: all 0.3s;
}

.more-link:hover {
  text-decoration: underline;
}

.module-content {
  flex: 1;
  display: flex;
  flex-direction: row;
  gap: 10px;
  margin: 5px;
}

.total-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 0 0 25%;
  border-radius: 4px;
  background-image: url('/static/image/six/total-count.png');
  background-repeat: no-repeat;
  background-position: center;
  background-size: 80% 100%;
}

.total-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.total-number {
  font-size: 36px;
  font-weight: bold;
  color: #02FFFC;
  line-height: 1;
  margin-bottom: 5px;
}

.total-label {
  font-size: 16px;
  color: #fff;
}

.stats-container {
  display: flex;
  flex-direction: column;
  gap: 5px;
  flex: 0 0 75%;
}

.stat-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: all 0.3s;
  height: 100%;
  cursor: pointer;
  border-radius: 4px;
  background-image: url('/static/image/six/background-frame.png');
  background-repeat: no-repeat;
  background-position: center;
  background-size: 95% 100%;
  padding: 0 40px 0 30px;
}

.stat-label {
  font-size: 12px;
  color: #fff;
  flex: 1;
}

.value-wrapper {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex: 1;
}

.stat-value {
  font-size: 18px;
  font-weight: bold;
  color: #02F5FF;
}

.stat-unit {
  font-size: 12px;
  color: #02F5FF;
  margin-left: 5px;
}




.stat-label {
  font-size: 13px;
  color: #fff;
}

.stat-value {
  font-size: 20px;
  font-weight: bold;
  color: #02F5FF;
}



.stat-unit {
  font-size: 12px;
  color: #fff;
}
</style>
